<template>
	<div>
        <v-tabs
            class="round-card"
            height="34"
            background-color="background-1"
            slider-color="primary">
            <v-tab key="Campi" ripple class="secondary-tab">
                Campi
            </v-tab>
			<v-tab key="Azioni" ripple class="secondary-tab">
				Azioni
			</v-tab>
            <v-tab key="Template" ripple class="secondary-tab">
                Template
            </v-tab>
            <v-tab key="Stampa" ripple class="secondary-tab">
                Stampa
            </v-tab>

            <v-tab-item class="background-1 pt-3 pb-1" key="Campi">
                <v-row class="ma-0">
                    <v-col class="pa-0 pt-2" cols="12">
                        <fields-selector model-def="suppliercreditnote"></fields-selector>
                    </v-col>
                </v-row>

                <v-row class="ma-0">
                    <v-col class="pa-0 pt-2" cols="12">
                        <fields-selector model-def="suppliercreditnoteproduct" audit></fields-selector>
                    </v-col>
                </v-row>

                <v-row class="ma-0">
                    <v-col class="pa-0 pt-2" cols="12">
                        <fields-selector model-def="suppliercreditnote" template-data="template_data_wizard" :table="false" :show="false" :custom-fields="false"></fields-selector>
                    </v-col>
                </v-row>
            </v-tab-item>

			<v-tab-item class="background-1 pt-3 pb-1" key="Azioni">
				<v-row class="ma-0">
					<v-col class="pa-0 pt-2" cols="12">
						<actions-selector model-def="suppliercreditnote"></actions-selector>
					</v-col>
				</v-row>
			</v-tab-item>

            <v-tab-item class="pb-offset background-1 pt-3" key="Template">
                <v-row class="ma-0 pb-offset">
                    <v-col class="pa-0 pb-4" cols="12">
                        <crud
                            model-def="templates-suppliercreditnote"
                            action-icon="dynamic_feed"
                            title="Template NdC Fornitore"
                            action-position='absolute'>
                        </crud>
                    </v-col>
                </v-row>
            </v-tab-item>

            <v-tab-item class="pb-offset background-1 pt-3" key="Stampa">
                <v-row class="ma-0 pb-offset">
                    <v-col class="pa-0" cols="12">
                        <print-setting model="suppliercreditnote" class="pt-0"></print-setting>
                    </v-col>
                </v-row>
            </v-tab-item>

        </v-tabs>
    </div>
</template>

<script>
    import PrintSetting from '@/components/common/PrintSetting'
    import FieldsSelector from '@/components/common/FieldsSelector'
    import ActionsSelector from '@/components/common/ActionsSelector'

    export default {
        name: 'suppliercreditnote-settings',
		components: {
            PrintSetting,
            FieldsSelector,
            ActionsSelector
		},
        data() {
            return {

            }
        },

        mounted() {
            this.$store.commit('endProgress')
        }

    }
</script>
